<!-- Заголовок дерева -->
<ng-container *ngIf="service.config?.titleTree">
    <div class="tree-title-block tree-title-block-margin-bottom">
        {{ service.config?.titleTree }}
        <button
            type="button"
            class="tree-title-block-right button-icon button-icon-background"
            mat-button
            [class.active]="expandAll"
            (click)="expandAllToggle()"
            [title]="
                expandAll
                    ? appService.language_dictionary.report_collapse_all
                    : appService.language_dictionary.report_expand_all
            "
        >
            <mat-icon>format_line_spacing</mat-icon>
        </button>
    </div>
</ng-container>

<div class="tree-panel flex flex-row overflow-hidden">
    <div fxFlex="1 1 calc(100% - 230px)" fxLayout="row">
        <app-input-search
            [label]="appService.language_dictionary.input_search_placeholder"
            [showToggleArrowButtons]="true"
            [positionIcon]="'left'"
            [icon]="'magnify'"
            [disableDown]="service.filterResultIndex === service?.filterResult?.length - 1"
            [disableUp]="service.filterResultIndex < 1"
            (switching)="showFilteredNode($event)"
            (inputEvent)="changeFilterRow($event)"
        >
        </app-input-search>
    </div>
    <div fxFlex="1 1 230px" class="add-options-block">
        <div class="add-options-row flex flex-row gap-x-[20px] items-center">
            <ng-container *ngFor="let item of service.config?.additionalOptions">
                <div [matTooltip]="item.title" class="option-block">
                    <i [class]="'mdi mdi-' + item.icon"></i>
                </div>
            </ng-container>
        </div>
    </div>
</div>

<div class="tree-select-container tree-select-container-padding">
    <div fxLayout="column" class="tree-block">
        <div class="tree-scroll-div-wrapper">
            <div class="tree-scroll-div">
                <div class="h-full">
                    <div fxLayout="column" fxFlex="1 1 100%">
                        <div class="tree-scroll-div-wrapper">
                            <div
                                #treeContainer
                                fxLayout="row"
                                class="tree-scroll-div"
                                [id]="'treeContainer-' + this.service.config.id"
                            >
                                <mat-tree
                                    [id]="this.service.config.id"
                                    fxFlex="1 1 calc(100% - 250px)"
                                    [dataSource]="service.dataSource"
                                    [treeControl]="treeControl"
                                    class="tree-select-tree"
                                >
                                    <mat-tree-node
                                        data-id="{{ node.id }}"
                                        hoverDirective
                                        (hover)="onNodeHover($event, 'tree1node-' + node.id)"
                                        [ngClass]="'tree1node-' + node.id"
                                        #treeNode="matTreeNode"
                                        #treeNodeRef
                                        *matTreeNodeDef="let node"
                                        [matTreeNodePadding]="node?.level"
                                        class="mat-tree-node"
                                        [class.mat-tree-node-focused]="service.focusedNode?.id == node.id"
                                        [class.mat-tree-node-selected]="service.selectNode?.id == node.id"
                                    >
                                        <mat-checkbox
                                            [disableRipple]="true"
                                            class="checklist-leaf-node"
                                            [disabled]="node.disabled"
                                            [checked]="
                                                service.checklistSelection.isSelected(node?.id | formater: 'string')
                                            "
                                            (change)="itemSelectionToggle(node); checkAutoSet($event, node)"
                                        >
                                            <mat-label
                                                class="mat-tree-node-item"
                                                [highlight]="treeSearch"
                                                [matTooltip]="node.name"
                                                [text]="node.name"
                                            ></mat-label>
                                        </mat-checkbox>
                                    </mat-tree-node>
                                    <mat-tree-node
                                        *matTreeNodeDef="let node; when: hasChild"
                                        #treeNode="matTreeNode"
                                        #treeNodeRef
                                        [matTreeNodePadding]="node?.level"
                                        hoverDirective
                                        (hover)="onNodeHover($event, 'tree1node-' + node.id)"
                                        data-id="{{ node.id }}"
                                        class="mat-tree-node tree1node-{{ node.id }}"
                                        [ngClass]="{
                                            'mat-tree-node-focused': service.focusedNode?.id == node.id,
                                            'mat-tree-node-selected': service.selectNode?.id == node.id,
                                        }"
                                    >
                                        <div class="mat-tree-node mat-tree-node-parent">
                                            <mat-checkbox
                                                [disableRipple]="true"
                                                [disabled]="node.disabled"
                                                [checked]="descendantsAllSelected(node)"
                                                [indeterminate]="descendantsPartiallySelected(node)"
                                                (change)="itemSelectionToggle(node); checkAutoSet($event, node)"
                                            >
                                                <div class="expand-button">
                                                    <fui-button
                                                        *ngIf="node.hasOwnProperty('children')"
                                                        (clickEvent)="$event.stopPropagation(); toggleNode(node)"
                                                        tabindex="-1"
                                                        [disabled]="node.children?.length == 0"
                                                        [type]="'button-icon'"
                                                        [icon]="
                                                            treeControl.isExpanded(node)
                                                                ? 'chevron-down'
                                                                : 'chevron-right'
                                                        "
                                                        [height]="'slim'"
                                                        [color]="'flat'"
                                                        [borderRadius]="'circle'"
                                                        [iconSize]="20"
                                                    >
                                                    </fui-button>
                                                </div>
                                                <mat-label
                                                    class="mat-tree-node-item"
                                                    [highlight]="treeSearch"
                                                    [matTooltip]="node.name"
                                                    [text]="node.name"
                                                ></mat-label>
                                            </mat-checkbox>
                                        </div>
                                    </mat-tree-node>
                                </mat-tree>
                                <mat-tree
                                    [id]="'addOption' + this.service.config.id"
                                    [dataSource]="service.dataSource"
                                    [treeControl]="treeControl"
                                    class="fake-node"
                                >
                                    <mat-tree-node
                                        data-id="{{ node.id }}"
                                        hoverDirective
                                        [ngClass]="'tree2node-' + node.id"
                                        (hover)="onNodeHover($event, 'tree2node-' + node.id)"
                                        #treeNodeOption="matTreeNode"
                                        #treeNodeOptionRef
                                        class="item-node"
                                        [class.mat-tree-node-focused]="service.focusedNode?.id == node.id"
                                        [class.mat-tree-node-selected]="service.selectNode?.id == node.id"
                                        *matTreeNodeDef="let node"
                                    >
                                        <ng-container
                                            [ngTemplateOutlet]="addOptionsTemplate"
                                            [ngTemplateOutletContext]="{ node: node }"
                                        >
                                        </ng-container>
                                    </mat-tree-node>
                                    <mat-tree-node
                                        class="folder-node"
                                        #treeNodeOption="matTreeNode"
                                        #treeNodeOptionRef
                                        data-id="{{ node.id }}"
                                        hoverDirective
                                        (hover)="onNodeHover($event, 'tree2node-' + node.id)"
                                        [ngClass]="'tree2node-' + node.id"
                                        [class.mat-tree-node-focused]="service.focusedNode?.id == node.id"
                                        [class.mat-tree-node-selected]="service.selectNode?.id == node.id"
                                        *matTreeNodeDef="let node; when: hasChild"
                                    >
                                        <ng-container
                                            [ngTemplateOutlet]="addOptionsTemplate"
                                            [ngTemplateOutletContext]="{ node: node }"
                                        >
                                        </ng-container>
                                    </mat-tree-node>
                                </mat-tree>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- Шаблон дополнительных опций для дерева -->
<ng-template #addOptionsTemplate let-node="node">
    <div fxLayout="row" class="add-options-row">
        <ng-container *ngFor="let item of service.config?.additionalOptions">
            <div class="check-box-block">
                <ng-container *ngIf="item.hasOwnProperty('conditionField'); else elseTemplate">
                    <ng-container *ngIf="node[item.conditionField] === '1'">
                        <mat-checkbox
                            [disableRipple]="true"
                            [id]="'option' + item.field + node.id"
                            [disabled]="!service.checklistSelection.isSelected(node?.id | formater: 'string')"
                            (change)="changeOption($event, node, item)"
                            [indeterminate]="indeterminateOption(node, item)"
                            [checked]="isSetOption(node, item)"
                        >
                        </mat-checkbox>
                    </ng-container>
                </ng-container>
                <ng-template #elseTemplate>
                    <mat-checkbox
                        [disableRipple]="true"
                        [id]="'option' + item.field + node.id"
                        [disabled]="
                            !this.service.checklistSelection.isSelected(node?.id | formater: 'string') &&
                            !descendantsPartiallySelected(node)
                        "
                        (change)="changeOption($event, node, item)"
                        [indeterminate]="indeterminateOption(node, item)"
                        [checked]="isSetOption(node, item)"
                    >
                    </mat-checkbox>
                </ng-template>
            </div>
        </ng-container>
    </div>
</ng-template>
